var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterJobsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97 97",
    style: {
      enableBackground: "new 0 0 97 97"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st001{fill:#15E6E8;}\n\t.st011{fill-rule:evenodd;clip-rule:evenodd;fill:#15E6E8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st001",
    d: "M93.18,72.73h2.02c0,0.81-0.4,2.02-0.4,2.83c-0.84,4.77-2.93,9.23-6.06,12.93c-3.6,3.28-8.1,5.39-12.93,6.06 c-0.81,0-1.62,0.4-2.83,0.4v-10.1c-0.01-3.25,1.14-6.4,3.23-8.89c2.6-2.23,5.87-3.51,9.29-3.64h6.06 C92.04,72.64,92.61,72.79,93.18,72.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st011",
    d: "M94.79,21.43c-0.84-4.77-2.93-9.23-6.06-12.93c-3.6-3.28-8.1-5.39-12.93-6.06c-9.04-1.84-18.25-2.65-27.47-2.42 c-9.06-0.14-18.12,0.53-27.06,2.02C11.23,3.48,3.33,11.38,1.89,21.43c-1.49,8.94-2.16,18-2.02,27.06 c-0.14,9.06,0.53,18.12,2.02,27.06c0.84,4.77,2.93,9.23,6.06,12.93c3.6,3.28,8.1,5.39,12.93,6.06c9.04,1.84,18.25,2.65,27.47,2.42 c5.66,0,10.5,0,14.95-0.4V84.85c0.21-5.66,2.34-11.08,6.06-15.35c4.2-3.88,9.64-6.17,15.35-6.46c2.42-0.2,4.85-0.2,7.27,0h4.85 V48.49C96.96,39.43,96.28,30.37,94.79,21.43z M28.15,24.26h12.12c2.1-0.13,3.91,1.48,4.04,3.58c0.01,0.15,0.01,0.31,0,0.46 c0.13,2.1-1.48,3.91-3.58,4.04c-0.15,0.01-0.31,0.01-0.46,0H28.15c-2.1,0.13-3.91-1.48-4.04-3.58c-0.01-0.15-0.01-0.31,0-0.46 c-0.13-2.1,1.48-3.91,3.58-4.04C27.84,24.25,27.99,24.25,28.15,24.26z M68.54,52.53H28.15c-2.23,0-4.04-1.81-4.04-4.04 s1.81-4.04,4.04-4.04h40.39c2.23,0,4.04,1.81,4.04,4.04S70.77,52.53,68.54,52.53z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterJobsActive);
export default __webpack_public_path__ + "static/media/FooterJobsActive.ab0998c6b5276d66edfaae634e732ebf.svg";
export { ForwardRef as ReactComponent };